import { Product } from "#/common/interfaces/conversionworld/Product";
// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export default class Item extends Vue {
  @Prop()
  product!: Product;

  @Prop()
  translation!: object;

  @Prop({ default: false })
  autoWidth?: boolean;

  @Prop({ default: false })
  noImage?: boolean;

  @Prop({ default: false })
  NoCloseButton?: boolean;

  @Prop({ default: false })
  notAdded?: boolean;

  public remove() {
    this.$emit("removeProduct");
  }
  public add(event) {
    if (event) event.preventDefault();
    this.$emit("addProduct");
  }
}
